<div class="row">
	<div class="columns small-12 medium-4">
		<div class="row collapse">
			<div class="columns small-4">
				<radio [(model)]="contact.data.salutation" [value]="'female'" [name]="'salutation'" [label]="'contact.salution.female.label' | translate" [class]="" [form]="form"></radio>
			</div>
			<div class="columns small-4">
				<radio [(model)]="contact.data.salutation" [value]="'male'" [name]="'salutation'" [label]="'contact.salution.male.label' | translate" [class]="" [form]="form"></radio>
			</div>
			<div class="columns small-4 end">
				<radio [(model)]="contact.data.salutation" [value]="'divers'" [name]="'salutation'" [label]="'contact.salution.divers.label' | translate" [class]="" [form]="form"></radio>
			</div>
		</div>
	</div>
	<textfield [(model)]="contact.data.firstname" [name]="'firstname'" [label]="getLabelKeyForField('firstname') | translate" [required]="true" [wrapperClass]="'columns small-6 medium-4'" [form]="form"></textfield>
	<textfield [(model)]="contact.data.lastname" [name]="'lastname'" [label]="getLabelKeyForField('lastname') | translate" [required]="true" [wrapperClass]="'columns small-6 medium-4'" [form]="form"></textfield>
</div>
<div class="row">
	<textfield [(model)]="contact.data.company" [name]="'company'" [label]="getLabelKeyForField('company') | translate" [required]="false" [wrapperClass]="'columns small-12 medium-6 end'" [form]="form"></textfield>
</div>
<div class="row">
	<textfield [(model)]="contact.data.postal_code" [name]="'postal_code'" [label]="getLabelKeyForField('postal_code') | translate" [required]="true" [wrapperClass]="'columns small-6 medium-2'" [form]="form"></textfield>
	<textfield [(model)]="contact.data.city" [name]="'city'" [label]="getLabelKeyForField('city') | translate" [required]="true" [wrapperClass]="'columns small-6 medium-4'" [form]="form"></textfield>
	<textfield [(model)]="contact.data.street" [name]="'street'" [label]="getLabelKeyForField('street') | translate" [required]="true" [wrapperClass]="'columns small-12 medium-6'" [form]="form"></textfield>
</div>
<div class="row">
	<textfield [(model)]="contact.data.telephone" [name]="'telephone'" [label]="getLabelKeyForField('telephone') | translate" [required]="true" [wrapperClass]="'columns small-6'" [form]="form"></textfield>
	<textfield [(model)]="contact.data.email" [name]="'email'" [label]="getLabelKeyForField('email') | translate" [required]="true" [wrapperClass]="'columns small-6'" [form]="form" (onBlur)="correctEmailAddress()"></textfield>
</div>
<div class="row">
	<textfield [(model)]="contact.data.job" [name]="'job'" [label]="getLabelKeyForField('job') | translate" [required]="false" [wrapperClass]="'columns small-6'" [form]="form"></textfield>
	<textfield [(model)]="contact.data.birthday" [name]="'birthday'" [label]="getLabelKeyForField('birthday') | translate" [required]="false" [wrapperClass]="'columns small-6'" [form]="form"></textfield>
</div>

<div class="row column margin">
	<p [innerHTML]="'ti.hint.postalcode' | translate"></p>
</div>

<div class="row column">
	<label class="standalone" [class.error]="!form.get('remarks').valid && form.get('remarks').touched">{{'ti.contribution.remarks.label' | translate}}</label>
</div>
<div class="row">
	<div *ngFor="let option of remarksOptions; let i = index" class="column small-12 medium-6 checkbox-wrapper">
		<checkbox [(model)]="contact.data.additional['remarks' + i]" [name]="'remarks' + i" [value]="option.name" [uncheckedValue]="null" [label]="option.name" (modelChange)="setField('remarks')"></checkbox>
	</div>
	<div class="column small-12 medium-6 checkbox-wrapper">
		<checkbox [hasTextinput]="true" [(model)]="contact.data.additional['remarks' + remarksOptions.length]" [name]="'remarks' + remarksOptions.length" [value]="'Sonstige'" (modelChange)="setField('remarks')" [uncheckedValue]="null" [label]="'Sonstige:'"></checkbox>
	</div>
</div>

<div class="row column margin">
	<label class="standalone" [class.error]="!form.get('interest').valid && form.get('interest').touched">{{'ti.contribution.interests.label' | translate}}</label>
</div>
<div class="row">
	<div *ngFor="let option of interestsOptions; let i = index" class="column small-12 medium-6 checkbox-wrapper">
		<checkbox [(model)]="contact.data.additional['interest' + i]" [name]="'interest' + i" [value]="option.name" [uncheckedValue]="null" [label]="option.name" (modelChange)="setField('interest')"></checkbox>
	</div>
	<div class="column small-12 medium-6 checkbox-wrapper">
		<checkbox [hasTextinput]="true" [(model)]="contact.data.additional['interest' + interestsOptions.length]" [name]="'interest' + interestsOptions.length" [value]="'Sonstige'" (modelChange)="setField('interest')" [uncheckedValue]="null" [label]="'Sonstige:'"></checkbox>
	</div>
</div>

<div class="row margin">
	<messagefield [required]="false" [rows]="4" [wrapperClass]="'columns small-12'" [name]="'reason_for_participation'" [form]="form" [(model)]="contact.data.additional['reason_for_participation']" [label]="'ti.reason_for_participation' | translate"></messagefield>
</div>

<div class="row">
	<messagefield [required]="false" [rows]="4" [wrapperClass]="'columns small-12'" [name]="'association_work'" [form]="form" [(model)]="contact.data.additional['association_work']" [label]="'ti.association_work' | translate"></messagefield>
</div>

<div class="row margin column">
	<label class="standalone">{{ 'ti.contribution.subheadline' | translate }}</label>
</div>

<div class="row column checkbox-wrapper">
	<checkbox [(model)]="contact.data.additional['magazin_print']" [name]="'magazin_print'" [value]="true" [uncheckedValue]="false" [label]="'ti.contribution.magazin_print.checkbox' | translate" (click)="contact.data.additional['magazin_not'] = null;"></checkbox>
</div>
<div class="row column checkbox-wrapper">
	<checkbox [(model)]="contact.data.additional['magazin_pdf']" [name]="'magazin_pdf'" [value]="true" [uncheckedValue]="false" [label]="'ti.contribution.magazin_pdf.checkbox' | translate" (click)="contact.data.additional['magazin_not'] = null;"></checkbox>
</div>
<div class="row column checkbox-wrapper">
	<checkbox [(model)]="contact.data.additional['magazin_not']" [name]="'magazin_not'" [value]="true" [uncheckedValue]="false" [label]="'ti.contribution.magazin_not.checkbox' | translate" (click)="contact.data.additional['magazin_print'] = null; contact.data.additional['magazin_pdf'] = null;"></checkbox>
</div>

<div class="row margin">
	<div class="column small-12">
		<p class="border" [innerHTML]="'ti.hint.share_internal' | translate"></p>
	</div>
	<div class="column small-12">
		<p [innerHTML]="'ti.hint.share_internal2' | translate"></p>
	</div>
	<div class="column small-12 checkbox-wrapper">
		<checkbox [(model)]="contact.data.additional['share_internal']" [name]="'share_internal'" [value]="true" [uncheckedValue]="false" [label]="'contact.share_internal_optout.checkbox' | translate"></checkbox>
	</div>
	<div class="column small-12">
		<p [innerHTML]="'ti.hint.share_internal3' | translate"></p>
	</div>
</div>
